import { useActionWhenVisible } from 'client/common/hooks/useActionWhenVisible'
import { EMPTY_RESPONSE_INTERCEPTOR, useCrossSellFetch } from 'client/common/hooks/useCrossSellFetch'
import { useXSellAnalytic } from 'client/common/analytic/useXSellAnalytic'
import { BUNDLE_LIST_TYPE } from 'client/common/analytic/analytic'

export const useFetchBundleData = (props, inView) => {
  const type = 'bundles'
  const viewSize = 6

  const { data, error, loading, get } = useCrossSellFetch({ ...props, type, viewSize }, EMPTY_RESPONSE_INTERCEPTOR)
  const actionProps = {
    action: () => get(),
    inView,
    isActionDisabled: !!data
  }
  useActionWhenVisible(actionProps)
  const onProductClick = useXSellAnalytic(data, BUNDLE_LIST_TYPE)
  return { data, error, loading, onProductClick }
}
